var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(" Recent Referral ")]),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.getDaskboard,"fixed-header":"","height":"300"},scopedSlots:_vm._u([{key:"item.date",fn:function(ref){
var item = ref.item;
return [_c('pre',[_vm._v(_vm._s(_vm.moment.utc(item.date).format('DD-MM-YYYY HH:mm')))])]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }